(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.apasapplication === "undefined") {
        jQuery.extend(sm.portal.vm, { apasapplication: {} });
    }

    function InitializeSections(application, coreSections) {
        var apasSections = [];
        var accessibilityNeedModel = new sm.portal.vm.AccessibilityNeedViewModel();
        var languagesModel = new sm.portal.vm.LanguagesViewModel();
        var MakeSectionsRequired = {
            SetLanguagesRequired: ko.observable(false),
        }
        // Accessibility Needs
        apasSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 62,
            SectionName: 'AccessibilityNeed',
            SectionTitle: sm.portal.utility.getResourceValue('AccessibilityNeeds'),
            SectionNavTitle: sm.portal.utility.getResourceValue('Accessibility'),
            Applied: true,
            Required: false,
            SectionModel: accessibilityNeedModel,
            SectionTemplate: "AccessibilityNeedTemplate.APAS"
        }));

        application.LastSectionName('AccessibilityNeed');
        //Languages
        apasSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 62,
            SectionName: 'Languages',
            SectionTitle: sm.portal.utility.getResourceValue('Languages'),
            SectionNavTitle: sm.portal.utility.getResourceValue('Languages'),
            Applied: true,
            Completed: false,
            Required: MakeSectionsRequired.SetLanguagesRequired(),
            SectionModel: languagesModel,
            SectionTemplate: "LanguagesTemplate.APAS"
        }));
        return coreSections.concat(apasSections);
    }

    function MoveToNextSection(application, nextSectionObj) {
        if (nextSectionObj != null) {
            if (application.CurrentSectionName() === "Academic") {
                var isValid = application.GetSectionModel('Academic').ValidateModel();
                if (isValid) {
                    nextSectionObj.Active(true);
                }
            }
        }
    }

    function ExtractATO(application, submitModel, stdAttempt, stdPerson) {

        var personSecData = application.GetSectionModel('BasicPerson');
        var accessibilityNeedSecData = application.GetSectionModel('AccessibilityNeed');
        var languageSecData = application.GetSectionModel('Languages');
        // Construct the Person Identifier ATO Object
        submitModel.PersonIdentifier = ko.toJS(sm.portal.vm.apaspersoninformation.ExtractASNATO(personSecData));

        // Construct the Language ATO object        
        submitModel.LanguagesInformation = ko.toJS(languageSecData.ExtractATO());
        // Construct the Accessibility Need ATO object        
        submitModel.AccessibilityNeedsInformation = ko.toJS(accessibilityNeedSecData.ExtractATO());

        submitModel.AdmissionsInformation = ko.toJS(stdAttempt);

        return submitModel;
    }


    jQuery.extend(true,
        sm.portal.vm.apasapplication,
        {
            InitializeSections: InitializeSections,
            MoveToNextSection: MoveToNextSection,
            ExtractATO: ExtractATO
        });

})(jQuery);